<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import browser from '@/util/browser'
import eventcenter from '@/util/eventcenter'
import {
  getDevicesId
} from '@/util/manageDeviceId'
import userCommon from '@/common/user'
export default {

  data() {
    return {
      env: browser.vkhybrid ? 'isApp' : 'default'
    }
  },
  watch: {
  },
  async mounted() {
    this.$logService.addCommonParams({
      device_id: getDevicesId()
    }, true)
    eventcenter.on('xhr_req_toast', (msg) => {
      this.$showToast(msg)
    })
    try {
      const studentId = (await userCommon.getInfo()).studentId
      this.$logService.register({
        uid: studentId
      })
    } catch {

    }
  },
  methods: {
  },
  components: {}
}

</script>

<style>
@font-face {
  font-family: "VIPKID";
  src: url("./font/VIPKID.ttf");
}
@font-face {
  font-family: "PingFang-SC-Medium";
  src: local("PingFang-SC-Medium"), local("PingFangSC-Medium"),
    url("./font/NotoSansCJKsc-Medium.otf");
}
@font-face {
  font-family: "PingFangSC-Medium";
  src: local("PingFangSC-Medium"), local("PingFang-SC-Medium"),
    url("./font/NotoSansCJKsc-Medium.otf");
}
@font-face {
  font-family: "PingFangSC-Semibold";
  src: local("PingFang-SC-Semibold"), url("./font/NotoSansCJKsc-Bold.otf");
}
@font-face {
  font-family: "PingFang-SC-Semibold";
  src: local("PingFang-SC-Semibold"), url("./font/NotoSansCJKsc-Bold.otf");
}
@font-face {
  font-family: "PingFang-SC-Regular";
  src: local("PingFang-SC-Regular"), local("PingFangSC-Regular"),
    url("./font/NotoSansCJKsc-Regular.otf");
}
@font-face {
  font-family: "PingFang-SC-Bold";
  src: local("PingFang-SC-Bold"), local("PingFangSC-Bold"),
    local("PingFang-SC-Semibold"), url("./font/NotoSansCJKsc-Bold.otf");
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

input::-webkit-input-placeholder {
  line-height: normal !important;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

html,
body {
  user-select: none;
  margin: 0;
  padding: 0;
  background-color: rgba(247, 247, 247, 1);
  overscroll-behavior-y: none;
}

h1,
h2,
h3,
h4,
h5 {
  margin: 0;
  padding: 0;
}

button,
input,
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -moz-tap-highlight-color: rgba(0, 0, 0, 0);
  -ms-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>
